import React from 'react'
import LoadingOverlay from 'react-loading-overlay';
import PropagateLoader from "react-spinners/PropagateLoader";

class ContentLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        if (localStorage.getItem("Uid") !== null) {
            this.props.history.push('/auth/menu-settings');
        }

        document.body.classList.add("tenant-page");
        var elements = document.getElementsByClassName('full-page section-image');
        for (var index = 0; index < elements.length; index++) {
            elements[index].classList.add("df-bg-white");
        }

    }

    render() {
        return (<div className="content centerLoader">
            <LoadingOverlay
                active={true}
                spinner={<PropagateLoader
                    height={35}
                    width={5}
                    radius={2}
                    margin={2}
                    color={"#007bff"}
                />}
            ></LoadingOverlay></div>)
    }
}

export default ContentLoader;